import { render, staticRenderFns } from "./v2_manual_create_details.vue?vue&type=template&id=6f0a6c6b&scoped=true"
import script from "./v2_manual_create_details.vue?vue&type=script&lang=js"
export * from "./v2_manual_create_details.vue?vue&type=script&lang=js"
import style0 from "./v2_manual_create_details.vue?vue&type=style&index=0&id=6f0a6c6b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a6c6b",
  null
  
)

export default component.exports